module.exports = __webpack_public_path__ + "img/api-consultancy.262837c1.svg";